<template>
    <select style="width: 100%">
        <slot></slot>
    </select>
</template>

<script>
export default {
    props: {
        options: Array,
        value: Object,
        id: {
            type: String,
            default: 'id',
        },
        label: {
            type: String,
            default: 'text',
        },
    },
    mounted: function () {
        this.initOptions(this.options);
        this.initChangeListener();
    },
    destroyed: function () {
        $(this.$el).off().select2('destroy');
    },
    watch: {
        value: function (value) {
            if (value) {
                $(this.$el).val(value.id).trigger('change');
            }
        },
        options: function (options) {
            this.initOptions(options);
        },
    },
    methods: {
        initOptions: function (options) {
            let opts = options.map((option) => ({ id: option[this.id], text: option[this.label] }));
            let select = $(this.$el);
            select.select2({ data: opts });
            if (this.value) {
                select.val(this.value[this.id]);
            }
            select.trigger('change');
        },
        initChangeListener: function () {
            let vm = this;
            $(this.$el).on('change', function () {
                if (this.value) {
                    let selected = vm.options.find((option) => option[vm.id] == this.value);
                    vm.$emit('input', selected);
                }
            });
        },
    },
};
</script>